import { render, staticRenderFns } from "./ListMyDocuments.vue?vue&type=template&id=39b662ee&"
import script from "./ListMyDocuments.vue?vue&type=script&lang=js&"
export * from "./ListMyDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports